import * as React from 'react'
import { useController } from 'react-hook-form'
import * as S from '../SellerVerification.styles'
import type { FieldError, FieldValues, Path } from 'react-hook-form'

const isArrayOfObjects = (arr: any[]): arr is object[] => {
  return Array.isArray(arr) && arr.every((item) => typeof item === 'object')
}

const SelectInput = <T extends FieldValues>({
  name,
  label,
  placeHolder,
  values,
  showError = true,
  disabled = false,
  loading = false
}: SelectInputProps<T>) => {
  const { field, fieldState } = useController({
    name
  })

  return (
    <S.Input hasError={Boolean(fieldState.error)}>
      {label && <S.FormLabel htmlFor={name}>{label}</S.FormLabel>}

      {loading ? (
        <S.InputLoading data-testid="select-loading" />
      ) : (
        <select data-testid={name} id={name} disabled={disabled} {...field}>
          {(placeHolder || label) && (
            <option value="" disabled>
              {placeHolder || label}
            </option>
          )}

          {isArrayOfObjects(values)
            ? values.map(({ value, label }) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))
            : values.map((value) => (
                <option key={value} value={value}>
                  {value}
                </option>
              ))}
        </select>
      )}

      {fieldState.error && showError && (
        <S.FormHint error>{fieldState.error.message}</S.FormHint>
      )}
    </S.Input>
  )
}

export default SelectInput

interface SelectInputProps<T extends FieldValues> {
  name: Path<T>
  label?: string
  placeHolder?: string
  values: SelectValues
  error?: FieldError
  showError?: boolean
  loading?: boolean
  disabled?: boolean
}

type SelectValues =
  | string[]
  | number[]
  | { value: string | number; label: string }[]
